export class ReportDataSetFieldMapping {
  workflowId: string;
  templateCode: string;
  columnIndex: number;
}
